var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCanada = function SvgCanada(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#canada_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.706 11.618h-.412l.103-1.647c-.006-.087-.047-.11-.206-.103l-1.647.205s.309-.411.309-.617C5.853 9.25 4 7.912 4 7.912s.412-.103.515-.206c.103-.103-.412-1.235-.412-1.235s1.046.411 1.132.308c.087-.103.206-.514.206-.514s.824.926 1.03.926c.205 0-.412-2.265-.412-2.265s.515.412.72.412C6.985 5.338 7.5 4 7.5 4s.515 1.338.618 1.338c.103 0 .823-.412.823-.412s-.515 2.162-.412 2.265c.103.103 1.03-.926 1.03-.926s.103.411.206.514c.103.103 1.132-.308 1.132-.308s-.515 1.132-.412 1.235c.103.103.515.206.515.206S9.147 9.25 9.147 9.456c0 .206.206.617.206.617l-1.544-.205c-.124-.036-.167-.009-.206.103l.103 1.647ZM13 0h5v15h-5zM-3 0h5v15h-5z",
    fill: "#F93939"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "canada_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "#fff"
  })))));
};
export default SvgCanada;